import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
// import { useDropzone } from "react-dropzone";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
// import Alert from "@mui/material/Alert";
import DropzoneComponent from "./DropzoneComponent"; // Import the custom Dropzone
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const QualityReportPalletEdit = () => {
  let { id } = useParams();

  const [ordersLists, setOrdersLists] = useState([]);
  const [palletlist, setPlletlist] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  // IMAGE HANDLING STATES
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);
  const [packagingTypesLists, setPackagingTypesLists] = useState([]);

  const [showCropper, setShowCropper] = useState(false);
  const [reportid, setReportid] = useState(0);


  // const handleSelectChange = (name, selectedOption) => {
  //   const value = selectedOption ? selectedOption.value : "";
  //   updateFormikValue(name, value);
  //   customHandleInput({ target: { name, value } });
  // };

  // const updateFormikValue = (name, value) => {
  //   formik.setFieldValue(name, value);
  // };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  useEffect(() => {
    setPermission(FindModuleById(447));
    console.log(permission);


    axios.post("/helpers/production_types_consumable", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
    ).then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.production_types;
        let productslisting = products.map((customer, index) => ({
          label: customer.consumable_name,
          value: customer.id,
          key: `address-${index}`,
        }));
        setPackagingTypesLists(productslisting);

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });


    axios
      .get(`/quality-report/edit-pallet/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          console.log(response.data.data);
          //toast.error(response.data.data.production);
          setValue(response.data.data.quality_report);
          let reportt = response.data.data.report;
          setReportid(reportt[0].report_id)
          const fetchedPallets = response.data.data.report.items;
          setPlletlist(fetchedPallets);
          // Pre-fill images state for each pallet
          const all_imgs = fetchedPallets.map((pallet) =>
            pallet.pictures.map((picture) => picture)
          );
          setImages(all_imgs)
          let orderr = response.data.data.quality_report.order;
          axios.post(`/orders-quality-report/listing-shipped-delivered-current-new`,{orderr}, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }).then((response) => {
            if (response.data.code === 200) {
              let orders = response.data.data.orders;
              let orderlisting = orders.map((ord, index) => ({
                label: ord.po_number,
                value: ord.id,
                key: `order-${index}`,
              }));
              setOrdersLists(orderlisting);
            } else {
              console.log("API response is not an array");
            }
          }).catch((error) => {
            console.log(error);
          });


        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  const getQualityReportData = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      formik.setFieldValue('customer', '');
      formik.setFieldValue('loading_type', '');
      formik.setFieldValue('container_number',);
      formik.setFieldValue('product', '');
      formik.setFieldValue('ref', '');
      formik.setFieldValue('date', '');
    } else {
      const values_all = selectedOptions.map(item => item.value); // [15, 14]

      console.log(values_all);
      axios
        .post(`/orders/get-quality-reports-post`, { values_all }, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let quality_data = response.data.data.quality;
            //  console.log(quality_data);

            // Use setFieldValue to update the customer and other fields
            formik.setFieldValue('customer', quality_data.customer);
            formik.setFieldValue('loading_type', quality_data.loading_type);
            formik.setFieldValue('container_number', quality_data.container_number);
            formik.setFieldValue('product', quality_data.product);
            formik.setFieldValue('ref', quality_data.ref);
            formik.setFieldValue('date', quality_data.date);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }


  }

  console.log(backendErrors)

  const formik = useFormik({
    initialValues: {
      id: id,
      report_id: reportid,
      loading_condition_images: value.loading_images,
      order: value.order,
      sender: value.sender,
      customer: value.customer,
      container_number: value.container_number,
      loading_type: value.loading_type,
      product: value.product,
      ref: value.ref,
      date: value.date,

      pallets: palletlist,

    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {

      // const pallets12 = values.pallets.slice(-1);
      // console.log(pallets12);

      //values.pallets = pallets12;
      console.log("Form submitted with values: ", values); // Check if form submission triggers

      axios
        .post("/quality-report/update-2", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("update Report");
          if (response.data.code === 200) {

            console.log(values);
            setSubmitting(false);
            toast.success(response.data.message);
            //setBackendSuccess(response.data.message);
            setTimeout(() => {
              window.location.href = "/quality-reports/";
            }, 500);
          } else {
            setBackendErrors(response.data.error);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    },
  });




  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Converts file to Base64
      reader.onload = () => resolve(reader.result); // Base64 string
      reader.onerror = (error) => reject(error);
    });
  };

  const onDrop = useCallback(
    async (acceptedFiles, palletIndex) => {
      const filesArray = Array.from(acceptedFiles);
      const currentPictures = formik.values.pallets[palletIndex]?.pictures || [];

      try {
        const resizedImages = await Promise.all(
          filesArray.map(async (file) => {
            const base64Image = await fileToBase64(file);
            return resizeImage(base64Image, 1000, 1000); // Resize to 65mm x 65mm (approx. 246px x 246px)
          })
        );

        let updatedPictures = [...currentPictures, ...resizedImages];
        if (updatedPictures.length > 6) {
          updatedPictures.length = 6;
        }

        formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedPictures);

        setImages((prevImages) => {
          const newImages = Array.isArray(prevImages) ? [...prevImages] : [];
          newImages[palletIndex] = updatedPictures;
          return newImages;
        });
      } catch (error) {
        console.error("Error resizing images:", error);
      }
    },
    [formik]
  );


  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);



  const resizeImage = (base64Str, maxWidth, maxHeight) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64Str;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let { width, height } = img;

        // Calculate the new dimensions while maintaining aspect ratio
        if (width > maxWidth || height > maxHeight) {
          if (width > height) {
            height = (maxHeight / width) * height;
            width = maxWidth;
          } else {
            width = (maxWidth / height) * width;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        resolve(canvas.toDataURL("image/jpeg"));
      };
    });
  };



  const getCroppedImage = async (imageSrc) => {
    const image = new Image();
    image.src = imageSrc;

    return new Promise((resolve, reject) => {
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Set canvas size to the cropped area resolution
        const scaleX = image.naturalWidth / image.width; // Adjust for potential scaling
        const scaleY = image.naturalHeight / image.height;

        const croppedWidth = croppedAreaPixels.width * scaleX;
        const croppedHeight = croppedAreaPixels.height * scaleY;

        canvas.width = croppedWidth;
        canvas.height = croppedHeight;

        // Apply rotation and cropping
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.translate(-canvas.width / 2, -canvas.height / 2);

        ctx.drawImage(
          image,
          croppedAreaPixels.x * scaleX,
          croppedAreaPixels.y * scaleY,
          croppedWidth,
          croppedHeight,
          0,
          0,
          canvas.width,
          canvas.height
        );

        // Export as a high-quality image
        const base64Image = canvas.toDataURL("image/jpeg", 1.0); // 95% quality
        resolve(base64Image);
      };

      image.onerror = (err) => reject(err);
    });
  };


  const handleSaveCroppedImage = async (palletIndex, imgIndex) => {
    // setLoading(true);
    try {
      const croppedImageUrl = await getCroppedImage(
        images[palletIndex][imgIndex]
      );
      const updatedImages = [...formik.values.pallets[palletIndex].pictures];
      updatedImages[imgIndex] = croppedImageUrl;
      formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);

      // setImages((prev) => ({
      //   ...prev,
      //   [palletIndex]: updatedImages,
      // }));
      setImages((prevImages) => {
        const newImages = [...prevImages]; // Create a shallow copy of the outer array
        newImages[palletIndex] = [...newImages[palletIndex]]; // Create a shallow copy of the specific pallet's images
        newImages[palletIndex][imgIndex] = croppedImageUrl; // Update the specific image
        return newImages; // Return the updated array
      });
    } catch (error) {
      console.error("Error saving cropped image:", error);
    } finally {
      // setLoading(false);
    }

    setShowCropper(false);
  };




  const handleDeleteImage = (palletIndex, imgIndex) => {
    // Get a deep copy of the current state of pallets' pictures
    const updatedPallets = [...formik.values.pallets];

    // Ensure that we're working on a copy of the specific pallet's pictures array
    const currentPictures = [...(updatedPallets[palletIndex]?.pictures || [])];

    // Check if the image exists at the specified index and if it is a URL
    const imageToDelete = currentPictures[imgIndex];
    if (imageToDelete && imageToDelete.startsWith('http')) {
      // Extract and format the image path from the URL
      try {
        const parsedUrl = new URL(imageToDelete);
        const imagePath = parsedUrl.pathname.substring(1).replace(/\//g, '--'); // Convert path separators for the endpoint format

        // Call the function to delete the image from the database
        deletepalletImagefromDB(imagePath)
          .then((response) => {
            if (response.status === 'ok') {
              console.log('Image deleted successfully from database');
            } else {
              console.error('Failed to delete the image from database');
            }
          })
          .catch((error) => {
            console.error('Error deleting image from database:', error);
          });
      } catch (error) {
        console.error('Error parsing image URL:', error);
      }
    }

    // Remove the image from the local state
    if (currentPictures.length > imgIndex) {
      currentPictures.splice(imgIndex, 1); // Remove the image at imgIndex
    }

    // Update the specific pallet's pictures in the deep copy of the formik state
    updatedPallets[palletIndex].pictures = currentPictures;

    // Update formik's state with the modified copy
    formik.setFieldValue(`pallets`, updatedPallets);

    // Update the images state to reflect the change locally (for rendering)
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[palletIndex] = currentPictures;
      return newImages;
    });

    // Update currentImageIndex if necessary to prevent out-of-bounds issues
    if (imgIndex === currentImageIndex) {
      setCurrentImageIndex(Math.max(0, imgIndex - 1));
    }
  };

  const deletepalletImagefromDB = async (item_id) => {
    const response_data = { status: 'false' };
    try {
      const response = await axios.get(`/quality-report/pallet-image/delete/${item_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });

      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    } catch (error) {
      console.error("Error deleting the pallet image:", error);
      response_data.status = 'false';
    }

    return response_data;
  };


  // const handleImageClick = (imgIndex) => {
  //   setCurrentImageIndex(imgIndex);
  //   setShowCropper(true); // Show the cropper container when an image is clicked
  // };
  const [activePalletIndex, setActivePalletIndex] = useState(null);

  const handleImageClick = (palletIndex, imgIndex) => {
    setCurrentImageIndex(imgIndex);
    setActivePalletIndex(palletIndex); // Set the active pallet index to show the cropper for that pallet
    setShowCropper(true);
  };
  const handleMoveImage = (palletIndex, imgIndex, direction) => {
    // Create a copy of the current pallet's images
    const updatedImages = [...images[palletIndex]];

    // Swap the current image with the one in the direction
    const swapIndex = imgIndex + direction;
    [updatedImages[imgIndex], updatedImages[swapIndex]] = [
      updatedImages[swapIndex],
      updatedImages[imgIndex],
    ];

    // Update the images state
    setImages((prev) => {
      const newImages = [...prev];
      newImages[palletIndex] = updatedImages;
      return newImages;
    });

    // Update Formik state
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);
  };


  const removeQuality = (palletIndex, qcIndex) => {
    const updatedPallets = [...formik.values.pallets];
    const qualityChecks = updatedPallets[palletIndex].quality_check;

    if (qualityChecks.length > 1) {
      qualityChecks.splice(qcIndex, 1);
      formik.setFieldValue("pallets", updatedPallets);
    } else {
      toast.warn("At least one quality check is required.");
    }
  };
  const AddMoreQuality = (palletIndex) => {
    const updatedPallets = [...formik.values.pallets];
    updatedPallets[palletIndex].quality_check.push({ name: "", percentage: "" });
    formik.setFieldValue("pallets", updatedPallets);
  };


  const [loadingImageCropIndex, setLoadingImageCropIndex] = useState(null);
  const [showLoadingCropper, setShowLoadingCropper] = useState(false);


  const handleLoadingConditionDrop = async (acceptedFiles) => {
    const filesArray = Array.from(acceptedFiles);
    const currentImages = formik.values.loading_condition_images || [];

    try {
      const resizedImages = await Promise.all(
        filesArray.map(async (file) => {
          const base64Image = await fileToBase64(file);
          return resizeImage(base64Image, 1000, 1000);
        })
      );

      let updatedImages = [...currentImages, ...resizedImages];
      if (updatedImages.length > 3) {
        updatedImages.length = 3;
        toast.warn("Maximum 3 images allowed for loading condition.");
      }

      formik.setFieldValue("loading_condition_images", updatedImages);
    } catch (error) {
      console.error("Error uploading loading condition images:", error);
    }
  };
  const removeLoadingConditionImage = (index) => {
    const updatedImages = [...formik.values.loading_condition_images];
    updatedImages.splice(index, 1);
    formik.setFieldValue("loading_condition_images", updatedImages);
  };


  const handleSaveCroppedLoadingImage = async () => {
    try {
      const imageSrc = formik.values.loading_condition_images[loadingImageCropIndex];
      const croppedImage = await getCroppedImage(imageSrc);

      const updatedImages = [...formik.values.loading_condition_images];
      updatedImages[loadingImageCropIndex] = croppedImage;
      formik.setFieldValue("loading_condition_images", updatedImages);
    } catch (error) {
      console.error("Error cropping loading condition image:", error);
    } finally {
      setShowLoadingCropper(false);
    }
  };
  const handleSelectChangemultiOrder = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    formik.setFieldValue("order", values);
    customHandleInput({ target: { name: "order", value: values } });
    getQualityReportData(selectedOptions); // move call here, remove from JSX

  };
  console.log(images);
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />  <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Quality Report</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/quality-reports">Quality Report</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit  Quality Report</li>
                </ul>
              </div>
            </div>
          </div>
          {permission && permission.update === 1 && (

            <FormikProvider value={formik}>
              <form action="#" onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group status">
                      <label>Order PO Number</label>
                     {ordersLists.length > 0 && (
                          <Select
                             name="order"
                            value={ordersLists.filter(option =>
                              // Normalize both sides to strings to avoid type mismatch
                              (formik.values.order || []).map(String).includes(String(option.value))
                            )}
                            onChange={handleSelectChangemultiOrder} // single handler, no double-call
                            onBlur={formik.handleBlur}
                            options={ordersLists}
                            placeholder={ordersLists.length == 0 ? "Loading orders..." : "Select Order"}
                            isMulti={true}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isDisabled={ordersLists.length == 0} // disable while loading instead of hiding
                        
                            // name="order"
                            // value={ordersLists.filter(option => 
                            //   formik.values.order?.includes(option.value)
                            // )}
                            // onChange={(selectedOptions) => {
                            //   handleSelectChangemultiOrder(selectedOptions);
                            //   getQualityReportData(selectedOptions);
                            // }}
                            // onBlur={formik.handleBlur}
                            // options={ordersLists}
                            // placeholder="Select Order"
                            // isMulti={true}
                            // closeMenuOnSelect={false}
                            // hideSelectedOptions={false}
                          />
                        )}


                      <small>
                        {backendErrors.order && (
                          <span order="form-error mt-1">
                            {backendErrors.order}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Sender </label>
                      <input
                        type="text"
                        name="sender"
                        value={formik.values.sender}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.sender && (
                          <span className="form-error mt-1">
                            {backendErrors.sender}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Customer </label>
                      <input
                        type="text"
                        name="customer"
                        value={formik.values.customer}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.customer && (
                          <span className="form-error mt-1">
                            {backendErrors.customer}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Loading Type </label>
                      <input
                        type="text"
                        name="loading_type"
                        value={formik.values.loading_type}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.loading_type && (
                          <span className="form-error mt-1">
                            {backendErrors.loading_type}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Container Number </label>
                      <input
                        type="text"
                        name="container_number"
                        value={formik.values.container_number}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.container_number && (
                          <span className="form-error mt-1">
                            {backendErrors.container_number}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Product </label>
                      <input
                        type="text"
                        name="product"
                        value={formik.values.product}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.product && (
                          <span className="form-error mt-1">
                            {backendErrors.product}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>REF </label>
                      <input
                        type="text"
                        name="ref"
                        value={formik.values.ref}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.ref && (
                          <span className="form-error mt-1">
                            {backendErrors.ref}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Date </label>
                      <input
                        type="date"
                        name="date"
                        value={formik.values.date}
                        className="form-input form-control input-error"
                        onChange={(e) => {
                          formik.handleChange(e);
                          customHandleInput(e);

                        }}
                        onBlur={formik.handleBlur}
                      />
                      <small>
                        {backendErrors.date && (
                          <span className="form-error mt-1">
                            {backendErrors.date}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                </div>


                <FieldArray
                  name="pallets"
                  render={(arrayHelpers) => (
                    <div>
                      {console.log(arrayHelpers)}
                      {formik.values.pallets.map((item, palletIndex) => (
                        <div key={palletIndex}>
                          <div className="row">
                            <div className="col-md-12" style={{ fontSize: '20px' }}>Sample# {formik.values.pallets[palletIndex].pallet_number}</div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Enter Product/Variety </label>
                                <input
                                  type="text"
                                  className={`form-input form-control`}
                                  name={`pallets[${palletIndex}].product`}
                                  value={formik.values.pallets[palletIndex].product}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Enter Temperature ° </label>
                                <input
                                  type="text"
                                  className={`form-input form-control`}
                                  name={`pallets[${palletIndex}].temperature`}
                                  value={
                                    formik.values.pallets[palletIndex].temperature
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Enter Sample weight (g) </label>
                                <input
                                  type="text"
                                  className={`form-input form-control`}
                                  name={`pallets[${palletIndex}].sample_weight`}
                                  value={
                                    formik.values.pallets[palletIndex].sample_weight
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Enter Packaging </label>
                                {/* <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].packaging`}
                                value={formik.values.pallets[palletIndex].packaging}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              /> */}
                                <Select
                                  name={`pallets[${palletIndex}].packaging`}
                                  options={packagingTypesLists}
                                  value={packagingTypesLists.find(option => option.value == formik.values.pallets[palletIndex].packaging) || null} // Ensure correct format
                                  onChange={(selectedOption) => {
                                    formik.setFieldValue(`pallets[${palletIndex}].packaging`, selectedOption.value); // ✅ Store only value in Formik
                                    customHandleInput({
                                      target: {
                                        name: `pallets[${palletIndex}].packaging`,
                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                      },
                                    });
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Select"
                                  className="w-100"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Enter Lot number </label>
                                <input
                                  type="text"
                                  className={`form-input form-control`}
                                  name={`pallets[${palletIndex}].lot_number`}
                                  value={formik.values.pallets[palletIndex].lot_number}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Enter Country of origin </label>
                                <input
                                  type="text"
                                  className={`form-input form-control`}
                                  name={`pallets[${palletIndex}].country`}
                                  value={formik.values.pallets[palletIndex].country}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>
                            <div className="col-md-5">
                              <div className="form-group status">
                                <label>Enter Label conformity </label>
                                <input
                                  type="text"
                                  className={`form-input form-control`}
                                  name={`pallets[${palletIndex}].label_conformity`}
                                  value={
                                    formik.values.pallets[palletIndex].label_conformity
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="hidden"
                                  name={`pallets[${palletIndex}].token_number`}
                                  value={
                                    formik.values.pallets[palletIndex].token_number
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>

                            <div className="col-md-12" style={{ paddingBottom: '20px' }}>
                              <div className="row">
                                <div className="col-md-12">
                                  <h4 style={{ paddingTop: '10px' }}>Quality Check</h4>
                                </div>

                                {formik.values.pallets[palletIndex].quality_check.map((qc, qcIndex) => (
                                  <React.Fragment key={qcIndex}>
                                    <div className="row align-items-end">
                                      <div className="col-md-4">
                                        <div className="form-group status">
                                          <label>Quality</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`pallets[${palletIndex}].quality_check[${qcIndex}].name`}
                                            value={qc.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group status">
                                          <label>Quality %</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`pallets[${palletIndex}].quality_check[${qcIndex}].percentage`}
                                            value={qc.percentage}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group status">
                                          <label>Action</label><br />
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => removeQuality(palletIndex, qcIndex)}
                                          >
                                            × Delete
                                          </button>

                                          {/* Show Add More button only on the last row */}
                                          {qcIndex === formik.values.pallets[palletIndex].quality_check.length - 1 && (
                                            <button
                                              type="button"
                                              className="btn btn-primary"
                                              onClick={() => AddMoreQuality(palletIndex)}
                                              style={{ marginLeft: '10px' }} // Adding margin for space between buttons
                                            >
                                              + Add
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </React.Fragment>
                                ))}



                              </div>
                            </div>


                            <div className="col-md-12">
                              <h4 style={{ paddingTop: '10px', paddingBottom: '10px' }}>Photos of the Quality Check</h4>
                              <DropzoneComponent
                                palletIndex={palletIndex}
                                onDrop={onDrop} // Pass onDrop as a prop
                              />



                              <div
                                style={{
                                  display: "flex",
                                  marginTop: "20px",
                                  flexWrap: "wrap",
                                }}
                              >
                                {images[palletIndex]?.map((image, imgIndex) => (
                                  <div
                                    key={imgIndex}
                                    style={{
                                      position: "relative",
                                      margin: "10px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={image}
                                      alt={`preview ${imgIndex}`}
                                      style={{
                                        width: "150px",
                                        cursor: "pointer",
                                        border: currentImageIndex === imgIndex ? "2px solid blue" : "none",
                                      }}
                                      onClick={() => handleImageClick(palletIndex, imgIndex)}
                                    />
                                    <div style={{ marginTop: "5px" }}>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={imgIndex === 0} // Disable "Move Up" for the first image
                                        onClick={() => handleMoveImage(palletIndex, imgIndex, -1)}
                                        style={{ marginRight: "5px" }}
                                      >
                                        Up
                                      </Button>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={imgIndex === images[palletIndex].length - 1} // Disable "Move Down" for the last image
                                        onClick={() => handleMoveImage(palletIndex, imgIndex, 1)}
                                      >
                                        Down
                                      </Button>
                                    </div>
                                    <Button
                                      variant="contained"
                                      color="secondary"
                                      onClick={() => handleDeleteImage(palletIndex, imgIndex)}
                                      style={{
                                        marginTop: "5px",
                                        backgroundColor: "red",
                                        color: "white",
                                        fontSize: "10px",
                                      }}
                                    >
                                      x
                                    </Button>
                                  </div>
                                ))}
                              </div>

                              {images[palletIndex]?.length > 0 && (
                                <Dialog
                                  open={showCropper && activePalletIndex === palletIndex}
                                  onClose={() => setShowCropper(false)} // Close the popup
                                  fullWidth
                                  maxWidth="sm"
                                >
                                  <DialogTitle>Image Editor</DialogTitle>
                                  <DialogContent>
                                    <div
                                      style={{
                                        position: "relative",
                                        height: "400px",
                                        width: "100%",
                                      }}
                                    >
                                      <Cropper
                                        image={images[palletIndex][currentImageIndex]}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={1}
                                        rotation={rotation}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                      />
                                    </div>

                                    <div>
                                      <h4>Rotation</h4>
                                      <Slider
                                        value={rotation}
                                        onChange={(e, newValue) => setRotation(newValue)}
                                        min={0}
                                        max={360}
                                      />
                                    </div>

                                    <div>
                                      <h4>Zoom</h4>
                                      <Slider
                                        value={zoom}
                                        min={1}
                                        max={3}
                                        step={0.1}
                                        onChange={(e, newZoom) => setZoom(newZoom)}
                                      />
                                    </div>
                                  </DialogContent>

                                  <DialogActions>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={() => {
                                        handleSaveCroppedImage(palletIndex, currentImageIndex);
                                        setShowCropper(false); // Close the popup after saving
                                      }}
                                    >
                                      Save Cropped Image
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      color="secondary"
                                      onClick={() => setShowCropper(false)} // Close the popup without saving
                                    >
                                      Cancel
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              )}


                            </div>

                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                />
                <div className="col-md-12 mt-4">
                  <h4>Photos of the Loading Condition (Max 3)</h4>
                  <DropzoneComponent
                    palletIndex={-1}
                    onDrop={(acceptedFiles) => handleLoadingConditionDrop(acceptedFiles)}
                  />
                  <div style={{ display: "flex", marginTop: "20px", flexWrap: "wrap" }}>
                    {formik.values.loading_condition_images?.map((image, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          margin: "10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={image}
                          alt={`loading condition ${index}`}
                          style={{ width: "150px", cursor: "pointer", border: "1px solid #ccc" }}
                          onClick={() => {
                            setLoadingImageCropIndex(index);
                            setShowLoadingCropper(true);
                          }}
                        />
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => removeLoadingConditionImage(index)}
                          style={{
                            marginTop: "5px",
                            backgroundColor: "red",
                            color: "white",
                            fontSize: "10px",
                          }}
                        >
                          x
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>

                {formik.values.loading_condition_images?.length > 0 && (
                  <Dialog
                    open={showLoadingCropper}
                    onClose={() => setShowLoadingCropper(false)}
                    fullWidth
                    maxWidth="sm"
                  >
                    <DialogTitle>Edit Loading Condition Image</DialogTitle>
                    <DialogContent>
                      <div style={{ position: "relative", height: "400px", width: "100%" }}>
                        <Cropper
                          image={formik.values.loading_condition_images[loadingImageCropIndex]}
                          crop={crop}
                          zoom={zoom}
                          aspect={1}
                          rotation={rotation}
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                        />
                      </div>
                      <h4>Rotation</h4>
                      <Slider value={rotation} onChange={(e, val) => setRotation(val)} min={0} max={360} />
                      <h4>Zoom</h4>
                      <Slider value={zoom} min={1} max={3} step={0.1} onChange={(e, val) => setZoom(val)} />
                    </DialogContent>
                    <DialogActions>
                      <Button variant="contained" color="primary" onClick={handleSaveCroppedLoadingImage}>
                        Save
                      </Button>
                      <Button variant="outlined" color="secondary" onClick={() => setShowLoadingCropper(false)}>
                        Cancel
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}
                <div className="text-end mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={formik.isSubmitting}
                  >
                    Update Report
                  </button>
                </div>
              </form>
            </FormikProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default QualityReportPalletEdit;